import { render, staticRenderFns } from "./SendWhatsapp.vue?vue&type=template&id=50088380"
import script from "./SendWhatsapp.vue?vue&type=script&lang=js"
export * from "./SendWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports